import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'

/** หน้า ประวัติเกมส์ BTD */
const HistoryBtdPage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()

  return (
    <div className="htd-hist__stack">
      <h2 className="htd-hist__page-title">ประวัติเกมส์ BTD</h2>
      <div className="htd-hist__empty">
        <h4>ไม่มีรายการ</h4>
        <p>ยังไม่มีประวัติเกมส์ BTD ในขณะนี้</p>
      </div>
    </div>
  )
}

export default HistoryBtdPage
